import { render } from "./modal.vue?vue&type=template&id=c56de734"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"

import "./modal.vue?vue&type=style&index=0&id=c56de734&lang=scss"
script.render = render

export default script